"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const chapters = [{
  id: "ch1",
  number: "01",
  title: "Personenbezogene Daten",
  subDescription: "Grundlegende Informationen für Ihre Mitgliedschaft und Kommunikation.",
  content: "Wir erfassen Ihren Namen, Ihre E-Mail-Adresse und Ihre Telefonnummer ausschließlich zur Verwaltung Ihres Accounts und zur Bereitstellung unserer Services. Diese Daten bilden die Basis für die Kommunikation innerhalb unserer Community und ermöglichen es uns, Sie über wichtige Updates zu Ihrem Arbeitsplatz und Buchungen zu informieren."
}, {
  id: "ch2",
  number: "02",
  title: "Nutzungsstatistiken & WLAN",
  subDescription: "Anonymisierte Daten zur Optimierung unserer Infrastruktur.",
  content: "Bei der Nutzung unseres Netzwerks erfassen wir anonymisierte Daten über die Auslastung der Räumlichkeiten. Dies hilft uns zu verstehen, welche Bereiche des Coworking Spaces besonders beliebt sind, um unser Raumangebot und die technische Ausstattung stetig zu verbessern. Es werden keine individuellen Browserverläufe oder privaten Inhalte Ihrer Kommunikation überwacht."
}, {
  id: "ch3",
  number: "03",
  title: "Zahlungsinformationen",
  subDescription: "Sichere Abwicklung Ihrer Buchungen und Abonnements.",
  content: "Alle Zahlungsinformationen werden über zertifizierte Zahlungsdienstleister verarbeitet. Wir speichern selbst keine Kreditkartendaten in unseren Systemen. Die Erfassung Ihrer Rechnungsadresse ist gesetzlich für die ordnungsgemäße Buchhaltung notwendig. Ihre Finanzdaten werden nach höchsten Sicherheitsstandards verschlüsselt und geschützt."
}];
export default function BookContent() {
  return <section data-section-id="185128" id="data-collection" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Main Content Area */}
          <div className="lg:col-span-8 xl:col-span-9">
            
            {/* Header Section */}
            <div className="mt-8">
              <h1 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-foreground">
                Transparente Datenerhebung
              </h1>
              <span className="font-default text-lg text-muted-foreground mt-4 block">
                Datenschutz & Privatsphäre im Coworking Space
              </span>
            </div>

            {/* Divider */}
            <Separator className="my-8 bg-border" />

            {/* Data Categories List */}
            <div className="space-y-12">
              {chapters.map((chapter, i) => <div key={chapter.id} data-index={i} className="py-4">
                  <span className="font-default text-sm font-medium tracking-wider text-primary">
                    {chapter.number}
                  </span>
                  <h2 className="font-default text-2xl md:text-3xl font-bold mt-2 text-secondary">
                    {chapter.title}
                  </h2>
                  {chapter.subDescription && <p className="font-default text-muted-foreground mt-2 text-base md:text-lg">
                      {chapter.subDescription}
                    </p>}
                  <p className="font-default text-lg leading-relaxed mt-6 text-card-foreground bg-card rounded-[1.5rem] border border-border p-8 shadow-sm">
                    {chapter.content}
                  </p>
                </div>)}
            </div>

          </div>
          
          {/* Sidebar / Spacer */}
          <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
            {/* Reserved for potential secondary navigation or imagery */}
          </div>
        </div>
      </div>
    </section>;
}